var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99496 9.31023C6.10142 9.31023 4.56641 7.77521 4.56641 5.88168C4.56641 3.98814 6.10142 2.45312 7.99496 2.45312C9.88849 2.45312 11.4235 3.98814 11.4235 5.88168C11.4235 7.77521 9.88849 9.31023 7.99496 9.31023Z",
    fill: "#9A9FA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2154 9.31359C12.953 9.31359 11.9297 8.29025 11.9297 7.02789C11.9297 5.76553 12.953 4.74219 14.2154 4.74219C15.4777 4.74219 16.5011 5.76553 16.5011 7.02789C16.5011 8.29025 15.4777 9.31359 14.2154 9.31359Z",
    fill: "#9A9FA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.5625C2 17.8075 2.14521 18 2.33003 18H13.67C13.8548 18 14 17.8075 14 17.5625C14 13.94 11.3069 11 8 11C4.69307 11 2 13.94 2 17.5625Z",
    fill: "#9A9FA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4336 14.7142C10.4336 14.8753 10.5252 15.0019 10.6417 15.0019H17.7919C17.9084 15.0019 18 14.8753 18 14.7142C18 12.3319 16.3019 10.3984 14.2168 10.3984C12.1317 10.3984 10.4336 12.3319 10.4336 14.7142Z",
    fill: "#9A9FA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMembers);
export default __webpack_public_path__ + "static/media/TeamMembers.ea7d4a16ff499f926ffb4c0f89c3d2e0.svg";
export { ForwardRef as ReactComponent };